import { useSiteContent } from "../../hooks/useSiteContent";
import SectionHeading from "../SectionHeading";

const GetInvolved = () => {
  const content = useSiteContent(
    ["home_get_involved_join_url", "home_get_involved_message_url"],
    {
      home_get_involved_join_url: "https://forms.gle/X37mWwG3roZt8jpL8",
      home_get_involved_message_url: "https://forms.gle/TS5HGLAW9AeH86x29",
    }
  );

  return (
    <div>
      <div className="flex flex-col items-center">
        <div className="container px-4 mx-auto">
          <SectionHeading
            className="mb-8 text-center"
            lead="Get"
            emphasis="Involved"
          />
          <div className="flex flex-col md:flex-row md:justify-center md:space-x-8">
            <div className="flex flex-col items-center mb-8 md:mb-0">
              <a
                href={content.home_get_involved_join_url}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block mb-4"
              >
                <div className="bg-red rounded-2xl w-[200px] h-[50px] flex justify-center items-center transition-transform duration-300 ease-in-out transform hover:-translate-y-2">
                  <span className="text-white">Join Our Family</span>
                </div>
              </a>
              <p className="text-gray-600">Become a part of our community</p>
            </div>
            <div className="flex flex-col items-center">
              <a
                href={content.home_get_involved_message_url}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block mb-4"
              >
                <div className="bg-red rounded-2xl w-[200px] h-[50px] flex justify-center items-center transition-transform duration-300 ease-in-out transform hover:-translate-y-2">
                  <span className="text-white">Leave a Message</span>
                </div>
              </a>
              <p className="text-gray-600">
                Share your thoughts and suggestions
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetInvolved;
